import { extend, deepExtend, isFunction } from "./core";
export class Component {
    constructor(element, options) {
        this.options = {
            events: {}
        };
        this.element = element;
        this.options = options;
    }
    destroy() {
        this.element = null;
    }
    extendOptions(options) {
        this.options = deepExtend(this.options, options);
    }
    setOptions(options) {
        this.options = options;
    }
    trigger(eventName, args = {}) {
        const eventData = {
            defaultPrevented: false,
            preventDefault: () => {
                eventData.defaultPrevented = true;
            }
        };
        if (this.options.events && isFunction(this.options.events[eventName])) {
            this.options.events[eventName](extend(eventData, args, {
                sender: this
            }));
        }
        return eventData.defaultPrevented;
    }
}
